/**
 * Shared validation constants for MCP tools.
 *
 * Centralises the phase-name and question-ID patterns that were previously
 * duplicated across questions.ts, pipeline.ts, and orchestration.ts.
 */

/** Phase names: lowercase alphanumeric + hyphens, 1–31 chars. */
export const SAFE_PHASE = /^[a-z][a-z0-9-]{0,30}$/;

/** Question IDs: alphanumeric (case-insensitive) + hyphens, 1–64 chars. */
export const SAFE_QUESTION_ID = /^[a-z0-9][a-z0-9-]{0,63}$/i;

export function isValidPhase(phase: string): boolean {
  return SAFE_PHASE.test(phase);
}

export function isValidQuestionId(id: string): boolean {
  return SAFE_QUESTION_ID.test(id);
}
